<template>
    <div class="row">
        <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
            <div class="account-box">
                <router-link to="/" class="logo">
                    <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                </router-link>
                <div class="account-box-title text-right">یادآوری کلمه عبور</div>
                <div class="account-box-content">
                    <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                        <img style="position:absolute;top:40%;left:43%;z-index:100" src="/assets/img/loader/loader.svg" />
                    </div>
                    <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                        <li v-for="error in errors.all()">{{ error }}</li>
                    </ul>
                    <form @submit.prevent="validateForm" class="form-account">

                        <div class="form-account-title">شماره موبایل</div>
                        <div class="form-account-row">
                            <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                            <input name="username" class="input-field" type="text" v-model="user.UserName" v-validate="{ required: true, regex: /^0\d{10}$/ }" data-vv-as="شماره موبایل"
                                   placeholder="شماره موبایل خود را وارد نمایید">
                        </div>

                        <div class="form-account-row form-account-submit">
                            <div class="parent-btn">
                                <button type="submit" class="dk-btn dk-btn-info">
                                    یادآوری کلمه عبور
                                    <i class="fa fa-sign-in"></i>
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
                <div class="account-box-footer">
                    <div>
                        <router-link class="btn-redirect-page" to="/">بازگشت به صفحه اصلی</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility.js";
    export default {
        data() {
            return{
                user: {},
                isShowSppiner: false
            }
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        } ,
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/ForgetPassword/GenerateConfirmationCode/', 'post', JSON.stringify(this.user),
                            response => {
                                this.isShowSppiner = false;
                                this.$emit('redirectToConfirm', response.data.Value);
                            },
                            response => {
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            resetForm() {
                this.user = {};
                this.$validator.reset();
                this.$validator.errors.clear();
            }, 
        },
        beforeMount: function () {
            createPageTitle('یادآوری کلمه عبور');
        }

    }
</script>

<style scoped>
    .account-box {
        margin: 120px auto;
    }
    .btn-redirect-page {
        background-color: #fff8f8;
        border-bottom: 1px dashed #1ca2bd;
        margin-top: 10px;
        display: inline-block;
        border-radius: 5px;
        color: #1ca2bd;
        transition: all .3s;
        padding: 6px;
        font-size: 12px;
    }
    .account-box-footer {
        border-top: 1px solid rgba(0, 190, 214, .13);
        padding: 0 0 15px 0;
    }
        .btn-redirect-page:hover {
            transition: all .3s;
            color: #1ca2bd;
        }
</style>